import { Div } from '../../../../base/components/native/div'
import { HowItWorksItem } from './hiw-item'

export const HowItWorksItems = () => {

    const items = [
        {
            h: 96,
            icon: '/images/hiw-icon-g.png',
            text: 'Generate your art',
            description: 'Create unique designs with the help of Artificial Intelligence (AI).'
        },
        {
            icon: '/images/hiw-icon-c.png',
            text: 'Choose your product',
            description: 'Pick the apparel type (bag or t-shirt), your unique design, and the color and size.'
        },
        {
            icon: '/images/hiw-icon-o.png',
            text: 'Order and receive',
            description: 'Effortlessly order and receive your desired products with just a few clicks.'
        }
    ]
    const base = Div()
    items.forEach(item => {
        const itemEl = HowItWorksItem(item.icon, item.text, item.description, item.h)
        base.append(itemEl)
    })

    base.cssClass({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        '@media (max-width: 1100px)': {
            flexDirection: 'column',
        }
    })

    return base
}